import React from 'react';
import { image } from '../../../utils/data/baseUrl';

const Logo = React.forwardRef(function Logo({ logo }, ref) {
  return (
    <div className={'w-modal__logo'}>
      <img src={logo.includes('http') ? logo : image(logo)} />
    </div>
  );
});
export default Logo;
Logo.propTypes = {};
